import React, { useState } from 'react';

import { NotFound } from '@zapier/common-components';

import { useJoinIntegration } from 'app/developer-v3/hooks';

import Stages from './Stages';

import type { Service } from './Stages/Form/types';

type Stage = 'form' | 'error' | 'success' | 'admin';

function JoinIntegrationPage() {
  const [stage, setStage] = useState<Stage>('form');
  const [service, setService] = useState<Service>();
  const [integrationId, setIntegrationId] = useState('');

  const {
    isMutating: isSubmitting,
    mutate: joinIntegration,
  } = useJoinIntegration();

  const onSubmit = async ({ email }) => {
    if (service) {
      try {
        await joinIntegration({
          email,
          message: `I would like you to help support, share, and promote ${service.name}'s Zapier integration.`,
          serviceId: service.id,
        });
        setStage('success');
      } catch (error) {
        const [integrationIdNext] = new URL(error.url).pathname.match(/\d+/);
        setIntegrationId(integrationIdNext);

        const response = error.responseText
          ? JSON.parse(error.responseText)
          : {};
        const isAdminError = response.errors?.some?.((e: any) =>
          e.cause?.includes('LIMITED_COLLABORATOR_ALREADY_ADMIN')
        );
        setStage(isAdminError ? 'admin' : 'error');
      }
    }
  };

  return stage === 'form' ? (
    <Stages.Form
      isSubmitting={isSubmitting}
      onChangeService={setService}
      onSubmit={onSubmit}
      service={service}
    />
  ) : stage === 'error' ? (
    <Stages.ErrorView
      name={service.name}
      onClickRetry={() => setStage('form')}
    />
  ) : stage === 'success' ? (
    <Stages.SuccessView name={service.name} />
  ) : stage === 'admin' ? (
    <Stages.AlreadyAdminView
      integrationId={integrationId}
      name={service.name}
    />
  ) : (
    <NotFound />
  );
}

export default JoinIntegrationPage;
